/**
 * Gender field_data → breakdown list from form options (API `breakdown`).
 * Used only for Gender analytics display.
 */
export function getGenderBreakdown(genderFieldData) {
  if (!genderFieldData || typeof genderFieldData !== 'object') {
    return [];
  }

  if (Array.isArray(genderFieldData.breakdown) && genderFieldData.breakdown.length > 0) {
    return genderFieldData.breakdown.map((item) => ({
      key: String(item.key ?? item.label ?? ''),
      label: String(item.label ?? item.key ?? 'Unknown'),
      percentage: Math.round(Number(item.percentage) || 0),
      count: item.count != null ? Number(item.count) || 0 : null,
    }));
  }

  // Legacy flat keys if breakdown missing
  return Object.entries(genderFieldData)
    .filter(([key, value]) => key.endsWith('_percentage') && typeof value === 'number')
    .map(([key, value]) => {
      const raw = key.replace(/_percentage$/, '');
      const label = raw.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
      const countKey = `${raw}_count`;
      return {
        key: raw,
        label,
        percentage: Math.round(value),
        count:
          typeof genderFieldData[countKey] === 'number'
            ? genderFieldData[countKey]
            : null,
      };
    });
}
